export const FETCH_TICKET = 'FETCH_TICKET';
export const FETCH_TAPE_DELIVERIES = 'FETCH_TAPE_DELIVERIES';
export const CREATE_ACTION_OVER_ACCESS_PERMISSION = 'CREATE_ACTION_OVER_ACCESS_PERMISSION';
export const FETCH_TAPE_DELIVERY_BY_ID = 'FETCH_TAPE_DELIVERY_BY_ID';
export const SET_TAPE_CHANGE_TICKET = 'SET_TAPE_CHANGE_TICKET';
